<form class="mb-[24px]" [formGroup]="packageForm">
	<!-- Duration -->

	<div class="flex flex-row justify-between mt-[24px] py-2 min-h-[40px]">
		<p class="text-dark-grey font-bold text-font-16">
			{{ 'PACKAGES.DURATION' | translate }}
		</p>
		<div *ngIf="isEditMode">
			<button
				*ngIf="viewMode"
				(click)="viewMode = !viewMode"
				class="inline-block text-link text-font-14"
			>
				<img class="inline-block" src="./assets/images/edit-blue.svg" alt="" />

				{{ 'ACTIONS.EDIT' | translate }}
			</button>
		</div>
	</div>
	<div
		*ngIf="!isEditMode || !viewMode"
		class="flex flex-col custom-shadow px-[24px] py-[12px] gap-[14px] rounded-12px bg-off-white relative"
	>
		<!-- duration -->
		<!-- add & edit mode -->
		<div>
			<!-- <p *ngIf="!viewMode" class="text-font-12 text-dark-grey">
						{{ 'OFFERS.DURATION' | translate }}
					</p> -->
			<div class="w-full">
				<div class="p-[24px] border border-[#D9DBE9] rounded-[6px]">
					<mat-form-field
						appearance="outline"
						class="w-[100%]"
						(click)="datepicker.open()"
					>
						<mat-label class="text-dark-grey">{{
							'GENERAL_LABELS.START_DATE' | translate
						}}</mat-label>
						<input
							[dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'"
							matInput
							[min]="today"
							[matDatepicker]="datepicker"
							formControlName="startDate"
							[max]="getController('endDate')?.value"
						/>
						<img
							*ngIf="
								getController('startDate')?.value && !packageData?.hasBooking
							"
							(click)="getController('startDate').reset()"
							class="cursor-pointer absolute ltr:right-9 rtl:left-9 inline-block top-[15px]"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<img
							*ngIf="!getController('startDate')?.value"
							class="cursor-pointer absolute ltr:right-[10px] rtl:left-[10px] inline-block top-[15px]"
							src="./assets/images/calendar.svg"
							alt=""
						/>
						<mat-datepicker #datepicker> </mat-datepicker>
						<mat-error class="mt-1">
							<validation-message
								[controller]="getController('startDate')"
								controller_name="GENERAL_LABELS.START_DATE"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>

					<mat-form-field
						appearance="outline"
						class="w-[100%]"
						(click)="datepickerTo.open()"
					>
						<mat-label class="text-dark-grey">{{
							'GENERAL_LABELS.END_DATE' | translate
						}}</mat-label>
						<input
							[dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'"
							matInput
							[min]="
								getController('startDate')?.value
									? getController('startDate')?.value
									: today
							"
							[matDatepicker]="datepickerTo"
							formControlName="endDate"
						/>
						<img
							*ngIf="getController('endDate')?.value"
							(click)="getController('endDate').reset()"
							class="cursor-pointer absolute ltr:right-9 rtl:left-9 inline-block top-[15px]"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<img
							*ngIf="!getController('endDate')?.value"
							class="cursor-pointer absolute ltr:right-[10px] rtl:left-[10px] inline-block top-[15px]"
							src="./assets/images/calendar.svg"
							alt=""
						/>
						<mat-datepicker #datepickerTo> </mat-datepicker>
						<mat-error>
							<validation-message
								[controller]="getController('endDate')"
								controller_name="GENERAL_LABELS.END_DATE"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>
				<mat-error>
					<div
						class="whitespace-nowrap"
						*ngIf="
							getController('endDate').value <
								getController('startDate').value &&
							getController('endDate').value
						"
					>
						{{ 'VALIDATION.END_DATE_ERROR' | translate }}
					</div>
				</mat-error>
			</div>
		</div>
		<div *ngIf="!viewMode" class="flex justify-end">
			<button
				(click)="viewMode = !viewMode; initForm()"
				class="py-[10px] px-[24px] border-[1px] border-[#D9DBE9] rounded-6px text-dark-grey my-0 max-mobile:text-[8px] max-mobile:px-12px max-mobile:py-[6px] ltr:mr-12px rtl:ml-12px"
			>
				{{ 'ACTIONS.CANCEL' | translate }}
			</button>

			<button
				(click)="onSave(true); initForm(); viewMode = !viewMode"
				class="bg-gradient text-off-white py-[10px] px-[24px] rounded-6px max-mobile:px-12px max-mobile:py-[6px] max-mobile:text-[8px] max-mobile:m-0 max-mobile:leading-[20px]"
			>
				{{ 'ACTIONS.SAVE' | translate }}
			</button>
		</div>
	</div>
</form>
<!-- view mode -->
<div *ngIf="isEditMode && viewMode">
	<div class="flex justify-between mt-2" *ngIf="packageData?.startDate == null">
		<p class="text-dark-grey text-font-16 font-semibold">
			{{ 'PACKAGES.HAS_DURATION' | translate }}
		</p>
		<div class="lg:w-[36px] m-auto mx-2 event-pointer-none">
			<mat-slide-toggle
				[checked]="packageData?.startDate != null"
				hideIcon
			></mat-slide-toggle>
		</div>
	</div>
	<div
		*ngIf="packageData?.startDate != null"
		class="w-full m-0 p-0 border-solid border-b-2"
	>
		<p class="text-dark-grey text-font-12 font-DIN-bold m-0">
			{{ 'GENERAL_LABELS.START_DATE' | translate }}
		</p>
		<div class="">
			<p class="text-medium-gray text-font-16 mb-[8px]">
				{{ packageData?.startDate | date : 'dd / MM / yyy' : 'UTC' }}
			</p>
		</div>
	</div>
	<div *ngIf="packageData?.endDate != null" class="w-full pt-[17px] m-0 p-0">
		<p class="text-dark-grey text-font-12 font-DIN-bold m-0">
			{{ 'GENERAL_LABELS.END_DATE' | translate }}
		</p>
		<div class="">
			<p class="text-medium-gray text-font-16 mb-[8px]">
				{{ packageData?.endDate | date : 'dd / MM / yyy' : 'UTC' }}
			</p>
		</div>
	</div>
</div>
